import { IUrl } from "@/interfaces/IUrl";
import api from "@/api/api-v1-config";

const url: IUrl = window as never;

// Define URLs
const URL_PAY_CHANNEL_DETAIL = url.urls.payChannelDetail;
const URL_PAY_CHANNEL = url.urls.payChannel;
const URL_PAY_BALANCE = url.urls.payBalance;
const URL_PAY_SUCCESS = url.urls.paySuccess;
const URL_PAY_FAIL = url.urls.payFail;
const URL_PAY_ACTIVATED_CHANNELS = url.urls.payActivatedChannels;
const URL_PAY_GET_BALANCE = url.urls.payGetBalance;
const URL_PAY_HISTORY = url.urls.payHistory;
const URL_PAY_OPTIONS = url.urls.payOptions;
const URL_PAY_OPTIONS_SUCCESS = url.urls.payOptionsSuccess;
const URL_PAID_OPTIONS = url.urls.paidOptions;
const URL_AUTO_RENEWAL_OPTION = url.urls.autoRenewalOption;
const URL_PAY_OPTIONS_RENEWAL = url.urls.payOptionsRenewal;

/**
 * Информация для формы - Оплата (каналы)
 */
export async function payChannelDetailAxios() {
	return await api.get(URL_PAY_CHANNEL_DETAIL);
}

/**
 * Покупка каналов
 * @param payload
 */
export async function payChannelAxios(payload: {
	amount: number;
	type: number;
}) {
	return await api.post(URL_PAY_CHANNEL, payload);
}

/**
 * Пополнение баланса
 * @param payload
 */
export async function payBalanceAxios(payload: { amount: number }) {
	return await api.post(URL_PAY_BALANCE, payload);
}

/**
 * Успешное пополнение
 * @param payload
 */
export async function paySuccessAxios(payload: { id: number }) {
	return await api.post(URL_PAY_SUCCESS, payload);
}

/**
 * Оплата не прошла
 * @param payload
 */
export async function payFailAxios(payload: { id: number; payType: number }) {
	return await api.post(URL_PAY_FAIL, payload);
}

/**
 * Количество активированных каналов
 */
export async function payActivatedChannelsAxios() {
	return await api.get(URL_PAY_ACTIVATED_CHANNELS);
}

/**
 * Баланс партнера
 */
export async function payGetBalanceAxios() {
	return await api.get(URL_PAY_GET_BALANCE);
}

/**
 *  История покупок
 */
export async function payHistoryAxios() {
	return await api.get(URL_PAY_HISTORY);
}

/**
 * Покупка опций
 * @param payload
 */
export async function payOptionsAxios(payload: {
	optionsIds: Array<number>;
	instanceId: number;
	isPayMonth: boolean;
}) {
	return await api.post(URL_PAY_OPTIONS, payload);
}

/**
 * Покупка опций прошла успешно
 * @param payload
 */
export async function payOptionsSuccessAxios(payload: {
	id: number;
	instanceId: number;
	newExpired: number;
}) {
	return await api.post(URL_PAY_OPTIONS_SUCCESS, payload);
}

/**
 * Получаем список купленных опций для инстанса
 * @param payload
 */
export async function paidOptionsAxios(payload: { instanceId: number }) {
	return await api.get(URL_PAID_OPTIONS + "/" + payload.instanceId);
}

/**
 * Автопродление опции (для checkbox)
 * @param payload
 */
export async function autoRenewalOptionAxios(payload: {
	instanceId: number;
	optionId: number;
	isActive: number;
}) {
	return await api.post(URL_AUTO_RENEWAL_OPTION, payload);
}

// Продление опций
export async function payOptionsRenewalAxios(payload: {
	id: number;
	instanceId: number;
	newExpired: number;
}) {
	return await api.post(URL_PAY_OPTIONS_RENEWAL, payload);
}
